import { render, staticRenderFns } from "./PlacementsStartComponent.vue?vue&type=template&id=482c485a&"
import script from "./PlacementsStartComponent.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports